import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SharedModule } from '../../../../../shared/shared.module';
import { NotificationModule } from '../../../../business-components/notification/notification.module';
import { DropdownModule } from '../../../dropdown/dropdown.module';
import { HeaderComponent } from './header.component';
const PRIMENG_MODULES = [ButtonModule, OverlayPanelModule, AvatarModule];

@NgModule({
  declarations: [HeaderComponent],
  exports: [HeaderComponent],
  imports: [
    NotificationModule,
    CommonModule,
    TranslateModule,
    DropdownModule,
    SharedModule,
    ...PRIMENG_MODULES,
  ],
})
export class HeaderModule {}
